export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  return parts.length === 2
    ? decodeURIComponent(parts.pop().split(";").shift())
    : null;
};

export const templateReplace = (template, data) => {
  const pattern = /{\s*(\w+?)\s*}/g; // {property}
  return template
    ? template.replace(pattern, (_, token) => data[token] || "")
    : "";
};

export const getURLQueryParameterByName = (
  name,
  url = window.location.href
) => {
  const sanitizedName = name.replace(/[[]]/g, "\\$&");
  const regex = new RegExp(`[?&]${sanitizedName}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};

export const formatNumberByLocale = (number, locale = "zh-CN") => {
  const map = {
    "zh-CN": ",",
  };
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, map[locale]);
};

export const formatDate = (date, format) => {
  const map = {
    YYYY: date.getFullYear(),
    M: date.getMonth() + 1, // Months are zero-based in JavaScript
    D: date.getDate(),
    H: date.getHours(),
    m: date.getMinutes(),
    s: date.getSeconds(),
  };
  return format.replace(/YYYY|M|D|H|m|s/g, (matched) => map[matched]);
};

export const formatTimeByLocale = (time, locale = "zh-CN") => {
  const map = {
    "zh-CN": "YYYY年M月D日",
  };
  return formatDate(time, map[locale]);
};

export const trimHTMLTags = (str) =>
  str
    ? str
        .replace(/(<([^>]+)>)/gi, "")
        .replace(/(\r\n|\n|\r)/gm, "")
        .trim()
    : "";

export const getThresholdBreakpoints = (num) => {
  const initArray = [];
  for (let i = 0; i < num; i++) {
    initArray.push((1 / num) * i);
  }
  return initArray;
};

export const loadScript = (src) => {
  const headElement = document.head || document.getElementsByTagName("head")[0];
  const _importedScript = {};

  return new Promise((resolve, reject) => {
    if (src in _importedScript) {
      resolve();
      return;
    }
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.onerror = (err) => {
      headElement.removeChild(script);
      reject(new URIError(`The Script ${src} is no accessible.`));
    };
    script.onload = () => {
      _importedScript[src] = true;
      resolve();
    };
    headElement.appendChild(script);
    script.src = src;
  });
};

export const getWorkerUserId = () => {
  if (window.localStorage) {
    let lastUser = (window.localStorage.getItem("lastUser") || "")
      .replace("@nio.com", "")
      .replace("@nio.io", "")
      .replace("@niocapital.com", "");

    if (lastUser && /^[a-z]+\.[a-z]+[1-9]*(\.o)?$/.test(lastUser)) {
      return lastUser;
    }
  }

  return "";
};

export const downloadByUrls = async (urls = []) => {
  if (urls.length > 0) {
    if (urls.length === 1) {
      const url = urls[0];
      const cleanUrl = url.split("?")[0];
      const fileName = cleanUrl.split("/").pop();
      const link = document.createElement("a");
      if (!["zip", "mp4"].some((fileType) => fileName.includes(fileType))) {
        const response = await fetch(url).catch((error) =>
          console.error(error)
        );
        if (response) {
          const blob = await response.blob();
          link.href = URL.createObjectURL(blob);
        } else {
          link.href = url;
        }
      } else {
        link.href = url;
      }
      link.download = cleanUrl;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      // TODO: multiple version
    }
  }
};
